(function () {
    window.__matriculaFlowInProgress = window.__matriculaFlowInProgress || false;

    // ✅ Si abrimos login en otra pestaña, al volver a esta recargamos 1 vez
    (function setupReloadAfterLogin() {
      const KEY = "__matriculaReloadAfterLogin";

      function maybeReload() {
        if (localStorage.getItem(KEY) === "1") {
          localStorage.removeItem(KEY);
          window.location.reload();
        }
      }

      window.addEventListener("focus", maybeReload);
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible") maybeReload();
      });
    })();

  function isMatriculaProduct() {
    try {
      return (window.meta && window.meta.product && window.meta.product.tags || []).includes("fee:matricula");
    } catch (e) {
      return false;
    }
  }

  function getVendorSiglasFromProduct() {
    try {
      return (window.meta && window.meta.product && window.meta.product.vendor) || "";
    } catch (e) {
      return "";
    }
  }

  function vendorToHandleSuffix(vendor) {
    // Asumimos que "vendor" ya son siglas limpias como dijiste (sin espacios)
    return String(vendor || "").trim().toLowerCase();
  }

function getMatriculaHandleForVendor(vendorSiglasLower) {
  return "matricula-" + vendorSiglasLower; // tu convención
}

function isLoggedIn() {
  return window.__isLoggedIn === true;
}

function customerHasMatriculaVendor(vendorLower) {
  const arr = Array.isArray(window.__customerMatriculas) ? window.__customerMatriculas : [];
  return arr.includes(String(vendorLower || "").toLowerCase());
}

async function getFirstVariantIdByHandle(handle) {
  // cache para no pedirlo mil veces
  window.__matriculaVariantCache = window.__matriculaVariantCache || {};
  if (window.__matriculaVariantCache[handle]) return window.__matriculaVariantCache[handle];

  const res = await fetch("/products/" + handle + ".js", {
    credentials: "same-origin",
    headers: { "Accept": "application/json" }
  });

  if (!res.ok) throw new Error("No pude leer /products/" + handle + ".js (status " + res.status + ")");
  const product = await res.json();

  const variantId = product?.variants?.[0]?.id;
  if (!variantId) throw new Error("No encontré variant id en " + handle);

  window.__matriculaVariantCache[handle] = variantId;
  return variantId;
}

function setButtonLoading(form, loading) {
  const btn = form.querySelector('button[type="submit"], button[name="add"], [type="submit"]');
  if (!btn) return;

  const spinner = form.querySelector('.loading__spinner'); // IMPORTANT: Dawn usa este

  if (loading) {
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    btn.disabled = true;
    if (spinner) spinner.classList.remove('hidden');
  } else {
    btn.classList.remove('loading');
    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    if (spinner) spinner.classList.add('hidden');
  }
}

async function getCartJson() {
  const res = await fetch("/cart.js", {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });
  if (!res.ok) throw new Error("No pude leer /cart.js (status " + res.status + ")");
  return await res.json();
}

async function cartHasMatriculaForVendor(vendorLower) {
  const handle = getMatriculaHandleForVendor(vendorLower); // "matricula-ias", etc
  const cart = await getCartJson();
  const items = cart?.items || [];
  return items.some((it) => it?.handle === handle);
}

function getCartEl() {
  return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
}

function getPurchaseOrigin() {
  try {
    return sessionStorage.getItem("purchase_origin") || "";
  } catch (e) {
    return "";
  }
}

async function addItemsDawnLike(items, activeElement) {
  const cart = getCartEl();

  // Usá fetchConfig si existe (Dawn), sino armamos uno simple
  const config =
    typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/json' } };

  config.headers = config.headers || {};
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type']; // como Dawn

  const fd = new FormData();
  items.forEach((it, i) => {
    fd.append(`items[${i}][id]`, String(it.id));
    fd.append(`items[${i}][quantity]`, String(it.quantity));

    if (it.properties) {
      Object.entries(it.properties).forEach(([key, value]) => {
        fd.append(`items[${i}][properties][${key}]`, String(value));
      });
    }
  });

  let sectionIds = [];

  if (cart && typeof cart.getSectionsToRender === 'function') {
    sectionIds = cart.getSectionsToRender().map((s) => s.id);
  } else {
    // fallback Dawn típico para notification
    sectionIds = ['cart-notification', 'cart-icon-bubble'];
  }

  console.log('[matricula] cart element:', cart?.tagName);
  console.log('[matricula] sections requested:', sectionIds);

  fd.append('sections', sectionIds);
  fd.append('sections_url', window.location.pathname + window.location.search);

  if (cart && typeof cart.setActiveElement === 'function') {
    cart.setActiveElement(activeElement || document.activeElement);
  }

  config.body = fd;

  const routeUrl = (window.routes && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js';
  const addUrl = routeUrl.endsWith('.js') ? routeUrl : `${routeUrl}.js`;

  const res = await fetch(addUrl, config);
  const data = await res.json();

  console.log('[matricula] sections returned keys:', data?.sections ? Object.keys(data.sections) : null);

  if (data.status) throw new Error(data.description || data.message || 'Error al agregar al carrito');

  return { data, cart };
}

function renderSectionsManually(data) {
  if (!data?.sections) return;

  const sectionToSelector = {
    "cart-notification-product": "#cart-notification-product",
    "cart-notification-button": "#cart-notification-button",
    "cart-icon-bubble": "#cart-icon-bubble",
  };

  for (const [sectionId, html] of Object.entries(data.sections)) {
    const selector = sectionToSelector[sectionId] || `#${sectionId}`;
    const container = document.querySelector(selector) || document.getElementById(sectionId);

    console.log("[matricula] replace section", sectionId, "container found?", !!container);
    if (!container) continue;

    // 1) intentamos extraer SOLO el nodo esperado desde el HTML devuelto
    const doc = new DOMParser().parseFromString(html, "text/html");
    const freshNode = doc.querySelector(selector) || doc.getElementById(sectionId);

    if (freshNode) {
      container.innerHTML = freshNode.innerHTML;
    } else {
      // 2) fallback: si no existe wrapper, usamos el HTML completo tal cual
      container.innerHTML = html;
    }
  }
}

 function ensureModal() {
  if (document.getElementById("matricula-modal")) return;

  var modal = document.createElement("div");
  modal.id = "matricula-modal";
  modal.style.cssText =
    "position:fixed;inset:0;background:rgba(0,0,0,.55);display:none;align-items:center;justify-content:center;z-index:999999;padding:16px;";

  modal.innerHTML = `
    <div style="background:#fff;max-width:520px;width:100%;border-radius:12px;padding:18px 16px;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial">
      <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;">
        <h3 style="margin:0;font-size:18px;line-height:1.2;">Matrícula de la institución</h3>
        <button type="button" data-close style="border:0;background:transparent;font-size:20px;cursor:pointer;">×</button>
      </div>
      <p style="margin:12px 0 14px;color:#333;">
        ¿Ya tenés matrícula activa para esta institución?
      </p>
      <div style="display:flex;gap:10px;flex-wrap:wrap;">
        <button type="button" data-has="yes"
          style="padding:10px 12px;border-radius:10px;border:1px solid #111;background:#111;color:#fff;cursor:pointer;">
          Sí, ya tengo
        </button>
        <button type="button" data-has="no"
          style="padding:10px 12px;border-radius:10px;border:1px solid #111;background:#fff;color:#111;cursor:pointer;">
          No, agregar matrícula
        </button>
      </div>

      <div data-login-hint style="display:none;margin-top:14px;padding:10px;border-radius:10px;background:#f5f5f5;color:#111;">
        Para poder validar tu matrícula, necesitás <a href="/account/login" style="text-decoration:underline;">iniciar sesión</a>.
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  modal.addEventListener("click", async function (e) {
    var target = e.target;

    if (target === modal || target.matches("[data-close]")) {
      hideModal();
      return;
    }

    if (target.matches("[data-has='yes']")) {
      // ✅ al volver a esta pestaña, recargamos para que theme.liquid setee __isLoggedIn/__customerMatriculas
      localStorage.setItem("__matriculaReloadAfterLogin", "1");

      // Abrimos el login en otra pestaña
      window.open("/account/login", "_blank", "noopener,noreferrer");

      // Hint
      modal.querySelector("[data-login-hint]").style.display = "block";
      modal.querySelector("[data-login-hint]").innerHTML =
        `Iniciá sesión en la pestaña que se abrió. Cuando vuelvas a esta pestaña, se va a recargar automáticamente.`;

      return;
    }

    if (target.matches("[data-has='no']")) {
      hideModal();

      const form = window.__matriculaPendingForm;
      const vendorLower = window.__matriculaVendor;
      if (!form || !vendorLower) return;

      try {
        setButtonLoading(form, true);

        const handle = getMatriculaHandleForVendor(vendorLower);
        const matriculaVariantId = await getFirstVariantIdByHandle(handle);

        const fd = new FormData(form);
        const courseVariantId = fd.get("id");
        const qty = Number(fd.get("quantity") || 1);
        if (!courseVariantId) throw new Error("No encontré el variant id del curso.");

        window.__matriculaFlowInProgress = true;

        const alreadyHasMatricula = await cartHasMatriculaForVendor(vendorLower);

        const purchaseOrigin = getPurchaseOrigin();

        const courseItem = {
          id: Number(courseVariantId),
          quantity: qty,
        };

        if (purchaseOrigin) {
          courseItem.properties = {
            _origin: purchaseOrigin,
          };
        }

        const itemsToAdd = [courseItem];

        if (!alreadyHasMatricula) {
          itemsToAdd.push({ id: Number(matriculaVariantId), quantity: 1 });
        } else {
          console.log("[matricula] ya existe matricula en carrito, no la agrego de nuevo");
        }

        const { data } = await addItemsDawnLike(itemsToAdd, document.activeElement);

        if (!data?.sections) {
          console.warn("[matricula] Sin sections en respuesta:", data);
          window.location.href = "/cart";
          return;
        }

        renderSectionsManually(data);

        const cartDrawer = document.querySelector("cart-drawer");
        const cartNotif = document.querySelector("cart-notification");

        if (cartDrawer && typeof cartDrawer.open === "function") cartDrawer.open();
        else if (cartNotif && typeof cartNotif.open === "function") cartNotif.open();
        else if (cartNotif) cartNotif.classList.add("active");
      } catch (err) {
        console.error(err);
        window.location.href = "/cart";
      } finally {
        window.__matriculaFlowInProgress = false;
        setTimeout(() => setButtonLoading(form, false), 300);
      }
    }
  });
}

  function showModal() {
    var modal = document.getElementById("matricula-modal");
    if (!modal) return;
    modal.style.display = "flex";
    modal.querySelector("[data-login-hint]").style.display = "none";
  }

  function hideModal() {
    var modal = document.getElementById("matricula-modal");
    if (!modal) return;
    modal.style.display = "none";
  }

  function interceptAddToCart() {
  // CLICK: evita que Dawn haga el add por AJAX y muestre su popup
  document.addEventListener(
    "click",
    async function (e) {
        if (window.__matriculaFlowInProgress) return;
      var btn = e.target.closest('button[name="add"], button[type="submit"]');
      if (!btn) return;

      var form = btn.closest("form");
      if (!form) return;

      if (!form.action || !form.action.includes("/cart/add")) return;

      // No intervenimos si el producto es matrícula
      if (isMatriculaProduct()) return;

      // Guardamos para después
      window.__matriculaPendingForm = form;
      const vendorLower = vendorToHandleSuffix(getVendorSiglasFromProduct());
      window.__matriculaVendor = vendorLower;

      var variantInput = form.querySelector('input[name="id"]');
      window.__courseVariantId = variantInput ? variantInput.value : null;

      // si está logueado, no mostramos modal
      if (isLoggedIn()) {
        // si ya tiene matrícula activa (tag), dejamos que Dawn siga normal
        if (customerHasMatriculaVendor(vendorLower)) {
          window.__matriculaBypassOnce = true;
          form.requestSubmit ? form.requestSubmit() : form.submit();
          return;
        }

        // logueado pero NO la tiene: agregamos automático (curso + matrícula si no está en carrito)
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        try {
          setButtonLoading(form, true);
          window.__matriculaFlowInProgress = true;

          const handle = getMatriculaHandleForVendor(vendorLower);
          const matriculaVariantId = await getFirstVariantIdByHandle(handle);

          const fd = new FormData(form);
          const courseVariantId = fd.get("id");
          const qty = Number(fd.get("quantity") || 1);
          if (!courseVariantId) throw new Error("No encontré el variant id del curso.");

          const alreadyHasMatriculaInCart = await cartHasMatriculaForVendor(vendorLower);

          const purchaseOrigin = getPurchaseOrigin();

          const courseItem = {
            id: Number(courseVariantId),
            quantity: qty,
          };

          if (purchaseOrigin) {
            courseItem.properties = {
              _origin: purchaseOrigin,
            };
          }

          const itemsToAdd = [courseItem];
          if (!alreadyHasMatriculaInCart) {
            itemsToAdd.push({ id: Number(matriculaVariantId), quantity: 1 });
          }

          const { data } = await addItemsDawnLike(itemsToAdd, document.activeElement);

          if (!data?.sections) {
            window.location.href = "/cart";
            return;
          }

          renderSectionsManually(data);

          const cartDrawer = document.querySelector("cart-drawer");
          const cartNotif = document.querySelector("cart-notification");

          if (cartDrawer && typeof cartDrawer.open === "function") cartDrawer.open();
          else if (cartNotif && typeof cartNotif.open === "function") cartNotif.open();
          else if (cartNotif) cartNotif.classList.add("active");
        } catch (err) {
          console.error(err);
          window.location.href = "/cart";
        } finally {
          window.__matriculaFlowInProgress = false;
          setTimeout(() => setButtonLoading(form, false), 300);
        }

        return;
      }

      // 👇 NO logueado: flujo actual con modal
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      ensureModal();
      showModal();

    },
    true
  );

  // SUBMIT: por si alguien envía con Enter
    document.addEventListener(
  "submit",
  async function (e) {
    if (window.__matriculaFlowInProgress) return;

    // si estamos re-ejecutando el submit a propósito, no interceptar
    if (window.__matriculaBypassOnce) {
      window.__matriculaBypassOnce = false;
      return;
    }

    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes("/cart/add")) return;

    // No intervenimos si el producto es matrícula
    if (isMatriculaProduct()) return;

    // Guardamos para después
    window.__matriculaPendingForm = form;
    const vendorLower = vendorToHandleSuffix(getVendorSiglasFromProduct());
    window.__matriculaVendor = vendorLower;

    // ✅ LOGUEADO
    if (isLoggedIn()) {
      // si ya tiene matrícula activa (tag), dejamos que siga normal
      if (customerHasMatriculaVendor(vendorLower)) {
        return;
      }

      // logueado pero NO la tiene: agregamos automático (curso + matrícula si no está en carrito)
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      try {
        setButtonLoading(form, true);
        window.__matriculaFlowInProgress = true;

        const handle = getMatriculaHandleForVendor(vendorLower);
        const matriculaVariantId = await getFirstVariantIdByHandle(handle);

        const fd = new FormData(form);
        const courseVariantId = fd.get("id");
        const qty = Number(fd.get("quantity") || 1);
        if (!courseVariantId) throw new Error("No encontré el variant id del curso.");

        const alreadyHasMatriculaInCart = await cartHasMatriculaForVendor(vendorLower);

        const purchaseOrigin = getPurchaseOrigin();

        const courseItem = {
          id: Number(courseVariantId),
          quantity: qty,
        };

        if (purchaseOrigin) {
          courseItem.properties = {
            _origin: purchaseOrigin,
          };
        }

        const itemsToAdd = [courseItem];
        if (!alreadyHasMatriculaInCart) {
          itemsToAdd.push({ id: Number(matriculaVariantId), quantity: 1 });
        }

        const { data } = await addItemsDawnLike(itemsToAdd, document.activeElement);

        if (!data?.sections) {
          window.location.href = "/cart";
          return;
        }

        renderSectionsManually(data);

        const cartDrawer = document.querySelector("cart-drawer");
        const cartNotif = document.querySelector("cart-notification");

        if (cartDrawer && typeof cartDrawer.open === "function") cartDrawer.open();
        else if (cartNotif && typeof cartNotif.open === "function") cartNotif.open();
        else if (cartNotif) cartNotif.classList.add("active");
      } catch (err) {
        console.error(err);
        window.location.href = "/cart";
      } finally {
        window.__matriculaFlowInProgress = false;
        setTimeout(() => setButtonLoading(form, false), 300);
      }

      return;
    }

    // ✅ NO logueado: modal
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    ensureModal();
    showModal();
  },
  true
);
}

  function init() {
    interceptAddToCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
